import ApiClient from '@/services/apiClient';

export default class GPSCoordinates {
    latitude;
    longitude;

    constructor() {
        this.latitude = '';
        this.longitude = '';
    }

    static constructFromObject(data, obj) {
        obj = obj || new GPSCoordinates();
        if (data) {
            obj.latitude = ApiClient.convertToType(data['latitude'], 'Number');
            obj.longitude = ApiClient.convertToType(data['longitude'], 'Number');
        }
        return obj;
    }

    toJSON() {
        return {
            latitude: this.latitude,
            longitude: this.longitude,
        }
    }

    toString() {
        return `${this.latitude} ; ${this.longitude}`;
    }
}
